var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDcIbank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 25.5,
    height: 17.5,
    rx: 1.75,
    fill: "white",
    stroke: "#D4D4D5",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.10505C20 5.79017 17.2332 3.499 14.2016 3.5H11.5927C8.52501 3.4989 6 5.79087 6 9.10505C6 12.137 8.52508 14.6281 11.5927 14.6134H14.2016C17.2329 14.628 20 12.1362 20 9.10505Z",
    fill: "#0079BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6097 3.96973C8.80658 3.97059 6.53518 6.24736 6.53418 9.05729C6.53488 11.8668 8.80638 14.1432 11.6097 14.1442C14.4135 14.1434 16.6856 11.8668 16.686 9.05729C16.6856 6.24729 14.4136 3.97073 11.6097 3.96973Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40088 9.04344C8.40355 7.67035 9.25938 6.49946 10.4662 6.03418V12.052C9.25938 11.587 8.40351 10.4167 8.40088 9.04347V9.04344ZM12.7689 12.0535V6.03435C13.9762 6.49852 14.8334 7.67008 14.8355 9.0438C14.8333 10.418 13.9762 11.5887 12.7689 12.0537V12.0535Z",
    fill: "#0079BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcIbank);
export default __webpack_public_path__ + "static/media/DCIbank.4c6785c1035d91b8f333ceb82725b8d3.svg";
export { ForwardRef as ReactComponent };